import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import { useNavigate, useLocation } from "react-router-dom";
import Edit from "../../Assets/img/Edit.svg";
import Delete from "../../Assets/img/Delete.svg";
import Search1 from "../../Assets/img/search-normal.png";
import Search from "../../Assets/img/search.png";
import "../FAQ/FAQ.css";
import Loading from "../../Loading/loading";

const FAQ = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [faqList, setFaqList] = useState([]);
    const [allFaqs, setAllFaqs] = useState([]);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [category, setCategory] = useState("");
    const [loading, setLoading] = useState(true);
    const [rowsPerPage] = useState(6);
    const [totalPages, setTotalPages] = useState(1);
    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [categories, setCategories] = useState([]);
    const [languageId, setLanguageId] = useState(1);
    const [page, setPage] = useState(1);

    const fetchCategories = (langId = languageId) => {
        API.post("faqsCategory_list/condition", { language_id: langId })
            .then((res) => {
                const categoryData = res?.data?.data?.data || [];
                const activeCategories = categoryData.filter(
                    (cat) => cat.active === 1 || cat.active === "1"
                );
                setCategories(activeCategories);
            })
            .catch((err) => console.error("Failed to fetch categories:", err));
    };


    useEffect(() => {
        fetchCategories(languageId);
        fetchFAQs(false);
    }, [languageId]);

    const fetchFAQs = (shouldResetPage = false) => {
        setLoading(true);
        const payload = {
            language_id: languageId,
            search: search || "",
            status: status || "",
            category_id: category || "",
        };

        API.post("faqs_list/condition", payload)
            .then((res) => {
                const faqData = res?.data?.data?.data || [];
                setAllFaqs(faqData);
                setTotalPages(Math.ceil(faqData.length / rowsPerPage));

                if (shouldResetPage) {
                    setPage(1);
                }
            })
            .catch((err) => console.error("Failed to fetch FAQs:", err))
            .finally(() => setLoading(false));
    };


    useEffect(() => {
        const startIndex = (page - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        setFaqList(allFaqs.slice(startIndex, endIndex));
    }, [allFaqs, page, rowsPerPage]);

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };

    const confirmDelete = () => {
        if (!deleteId) return;
        API.post("faqs_delete/update", { faqs_id: deleteId, active: 4 })
            .then(() => {
                setShowPopup(false);
                setDeleteId(null);
                fetchFAQs();
            })
            .catch((err) => console.error("Failed to delete FAQ:", err));
    };


    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";
        API.post("faqs_status/update", { faqs_id: id, status: newStatus })
            .then(() => fetchFAQs())
            .catch((err) => console.error("Failed to update status:", err));
    };

    const handleNext = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) setPage(page - 1);
    };

    useEffect(() => {
        if (location.state?.page && allFaqs.length > 0) {
            setPage(location.state.page);
        }
    }, [location.state, allFaqs.length]);

    return (
        <div className="news-container">
            <div className="news-header">
                <h2 className="news-title">FAQ</h2>
                <button onClick={() => navigate("/faqadd")} className="add-btn">
                    <strong>+</strong> Add FAQ
                </button>
            </div>

            <div className="filter-row">
                <div className="filter-block">
                    <label>Search By</label>
                    <div className="input-container">
                        <input
                            placeholder="Search FAQs"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="input-field"
                        />
                        <img
                            src={Search1}
                            alt="Search"
                            className="search-icon"
                            onClick={() => fetchFAQs(true)}
                        />
                    </div>
                </div>

                <div className="filter-block">
                    <label>Status</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => setStatus(e.target.value)}
                            value={status}
                            className="input-field"
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Category</label>
                    <div className="input-container">
                        <select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="input-field"
                        >
                            <option value="">Select Category</option>
                            {categories.map((cat) => (
                                <option key={cat.category_id} value={cat.category_id}>
                                    {cat.category}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                                setPage(1);
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>
                <div className="filter-btn-wrapper" onClick={() => fetchFAQs(true)}>
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="news-grid1">
                        {faqList.length > 0 ? (
                            faqList.map((item) => (
                                <div key={item.faqs_id} className="news-card">
                                    <div className="card-footer">
                                        <div className="status-container">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(item.faqs_id, item.status)
                                                    }
                                                />
                                                <span className="slider round">
                                                    <span className="switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>

                                            <span className="status-text">
                                                {categories.find(
                                                    (cat) => cat.category_id === item.category_id
                                                )?.category || "Unknown"}
                                            </span>
                                        </div>

                                        <div className="action-buttons">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="edit-icon-btn"
                                                onClick={() =>
                                                    navigate(`/faqedit/${item.faqs_id}`, {
                                                        state: { faq: item, page },
                                                    })
                                                }
                                            />
                                            <img
                                                src={Delete}
                                                alt="Delete"
                                                className="edit-icon-btn"
                                                onClick={() => handleDeleteClick(item.faqs_id)}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="faq-content"
                                        onClick={() =>
                                            navigate(`/faqview/${item.faqs_id}`, {
                                                state: { faq: item, page },
                                            })
                                        }
                                        style={{ cursor: "pointer" }}
                                    >
                                        <h3 className="news-heading clickable-title">
                                            {item.question}
                                        </h3>
                                        <div
                                            className="news-description clickable-description"
                                            dangerouslySetInnerHTML={{ __html: item.answers }}
                                        ></div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-faq-text">No FAQs found.</p>
                        )}
                    </div>

                    {/*  Pagination */}
                    {totalPages > 1 && (
                        <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={handlePrev}
                                disabled={page === 1}
                            >
                               Prev
                            </button>
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                                (num) => (
                                    <button
                                        key={num}
                                        className={`pagination-btn ${page === num ? "active" : ""}`}
                                        onClick={() => setPage(num)}
                                    >
                                        {num}
                                    </button>
                                )
                            )}
                            <button
                                className="pagination-btn"
                                onClick={handleNext}
                                disabled={page === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </>
            )}

            {/* 🧩 Delete Popup */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Confirm Delete</h3>
                        <p>Are you sure you want to delete this FAQ?</p>
                        <div className="popup-buttons">
                            <button
                                className="cancel-btn "
                                onClick={() => setShowPopup(false)}
                            >
                                Cancel
                            </button>
                            <button className="btn delete-btn" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FAQ;
